/**************************************************
 * Nombre:       Formulario_Estado.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {FlagOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoRating from "../../../Modulo_formularios/Componentes/IngresoRating";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../../App";
import {ESTADOSFUNNEL} from "../../../Constantes";

const Formulario_Estado = ({...props}) => {
    const cData = useContext(usuarioContext)

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSFUNNEL.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Estado